import { Hidden, Stack } from '@mui/material';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

interface WarningAlertProps {
  message: string
}

export default function WarningAlert({ message }: WarningAlertProps) {
  return (
    <Stack
      sx={{
        width: '80%',
        position: 'fixed', // Mudado de 'absolute' para 'fixed'
        right: 0,
        top: '10px',
        transform: 'translateX(100%)', // Inicialmente fora da tela
        animation: 'slideIn 0.5s ease-out forwards, slideOut 0.5s ease-in 5s forwards',
        '@keyframes slideIn': {
          from: {
            transform: 'translateX(100%)',
            opacity: 0,
          },
          to: {
            transform: 'translateX(0)',
            opacity: 1,
          },
        },
        '@keyframes slideOut': {
          from: {
            transform: 'translateX(0)',
            opacity: 1,
          },
          to: {
            transform: 'translateX(100%)',
            opacity: 0,
          },
        },
        '@media (min-width: 700px)': {
          width: '40%',
        },
        zIndex: 1000,
      }}
      spacing={2}
    >
      <Alert severity="warning">
        <AlertTitle
          sx={{
            fontWeight: 'bold'
          }}
        >
          Atenção!
        </AlertTitle>
        {message}
      </Alert>
    </Stack>
  )
}